import image1 from "./images/home images/1.png";
import image2 from "./images/home images/2.png";
import image3 from "./images/home images/3.png";
import image4 from "./images/home images/4.png";
import image5 from "./images/home images/5.png";
import image6 from "./images/home images/6.png";
import image7 from "./images/home images/7.png";
import image8 from "./images/home images/8.png";

const Data = [
  {
    image: image1,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 4,
  },
  {
    image: image2,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image3,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 4,
  },
  {
    image: image4,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 2,
  },
  {
    image: image5,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image6,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 1,
  },
  {
    image: image7,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 2,
  },
  {
    image: image8,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 0,
  },
];

export default Data;
